import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-navy-950 border-t border-navy-800" data-id="element-63">
      <div className="container mx-auto px-4" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-gradient-to-br from-navy-900 to-navy-950 border border-navy-700 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-65">
          <div className="absolute top-0 right-0 p-8 opacity-5 pointer-events-none" data-id="element-66">
            <ShieldCheck className="w-64 h-64 text-white" data-id="element-67" />
          </div>

          <div className="relative z-10" data-id="element-68">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-500/10 text-green-500 mb-6" data-id="element-69">
              <ShieldCheck className="w-10 h-10" data-id="element-70" />
            </div>

            <h2 className="font-oswald text-xl text-gray-400 uppercase tracking-widest mb-2" data-id="element-71">
              YOUR INVESTMENT IS 100% PROTECTED
            </h2>
            <h3 className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-8" data-id="element-72">
              7-DAY FULL GUARANTEE
            </h3>

            <div className="prose prose-lg prose-invert mx-auto text-gray-300" data-id="element-73">
              <p className="font-medium text-white text-xl mb-4" data-id="element-74">
                Your money is completely protected.
              </p>
              <p className="mb-4" data-id="element-75">
                You have 7 full days to explore all 6 volumes, use the sessions,
                test the bonuses, and evaluate the system.
              </p>
              <p className="mb-8" data-id="element-76">
                If you're not completely satisfied, simply request a refund and
                we'll return 100% of your purchase.
              </p>
              <div className="font-oswald text-2xl text-gold-500 uppercase tracking-wider" data-id="element-77">
                Zero Risk For You.
                <br data-id="element-78" />
                Complete Commitment From Us.
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}